import { render, staticRenderFns } from "./PaginationPanel1.vue?vue&type=template&id=f34760d6&scoped=true"
import script from "./PaginationPanel1.vue?vue&type=script&lang=ts"
export * from "./PaginationPanel1.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanel1.vue?vue&type=style&index=0&id=f34760d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34760d6",
  null
  
)

export default component.exports